import React from "react";
import PlansBTableContainerV2 from "./PlansBTableContainerV2";

const PlanBContainerV2 = (props) => {
	const {
		tariffs,
		addFormOneClick,
		useYandexEvent,
		pageName,
		dataTest,
		isTS,
		pagination,
		new_house_url,
	} = props;
	if (!tariffs?.length) {
		return null;
	}

	return (
		<PlansBTableContainerV2
			tariffs={tariffs}
			isTS={isTS}
			addFormOneClick={addFormOneClick}
			useYandexEvent={useYandexEvent}
			pageName={pageName}
			dataTest={dataTest}
			pagination={pagination}
			new_house_url={new_house_url}
		/>
	);
};

export default PlanBContainerV2;
